import { render, staticRenderFns } from "./ProgramsThumbails.vue?vue&type=template&id=36827c6c&scoped=true"
import script from "./ProgramsThumbails.vue?vue&type=script&lang=js"
export * from "./ProgramsThumbails.vue?vue&type=script&lang=js"
import style0 from "./ProgramsThumbails.vue?vue&type=style&index=0&id=36827c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36827c6c",
  null
  
)

export default component.exports